import PengajuanSewa from "../../../components/kos/informasi-aktivitas/pengajuan-sewa-kos";

const InformasiAktivitas = () => {
    return (
        <div className="mt-5" id="informasi-aktivitas">
            <h3>Informasi Aktivitas</h3>
			<PengajuanSewa />		    
        </div>
    )
}

export default InformasiAktivitas;